require('angular');

const AtmtStickyBarController = ['$scope', '$document', '$element', function($scope, $document, $element) {
    const ctrl = this;
    ctrl.ngClass = {};
    ctrl.ngStyle = {};

    ctrl._checkVisibility = checkVisibility;

    initWatchers();

    /**
     * Watch for changes on the scope (from link fn)
     */
    function initWatchers() {
        $scope.$watch('documentScrollTop', function(documentScrollTop) {
            ctrl._checkVisibility(documentScrollTop);
        });
    }

    /**
     * Check if the element is still visible
     */
    function checkVisibility(documentScrollTop) {
        const offset = $('.navbar').outerHeight();
        const sticky = $scope.top - offset < documentScrollTop;
        if (sticky && !ctrl.isSticky) {
            $('.atmt-sticky-bar-pusher').height($($element).height());
        }
        ctrl.isSticky = sticky;
        ctrl.ngClass['atmt__sticky-bar--sticky'] = ctrl.isSticky;
        ctrl.ngStyle.top = offset + 'px';
    }
}];

const atmtStickyBarDirective = ['$document', '$window', '$timeout', function($document, $window, $timeout) {
    return {
        restrict: 'EA',
        scope: {},
        controller: 'AtmtStickyBarController',
        controllerAs: 'ctrl',
        bindToController: {
            isSticky: '=',
            resizeFlag: '='
        },
        transclude: true,
        link: function(scope, element, attrs, ctrl, transclude) {
            transclude(scope.$parent, clone => {
                const transcludeElement = angular.element('<div ng-transclude class="atmt-sticky-bar-wrapper"></div>');
                element.append(transcludeElement);
                transcludeElement.append(clone);
            });
            const stickyClassName = 'atmt__sticky-bar--sticky';
            scope.$watch(() => {
                return ctrl.ngClass;
            }, () => {
                const wrapper = $('.atmt-sticky-bar-wrapper');
                if (ctrl.ngClass[stickyClassName]) {
                    wrapper.addClass(stickyClassName);
                } else {
                    wrapper.removeClass(stickyClassName);
                }
                wrapper.attr('style', 'top:' + ctrl.ngStyle.top);
            }, true);
            function updateDocumentScrollTop() {
                scope.documentScrollTop = $($window).scrollTop();
            }
            function updateElTop() {
                scope.top = $(element).offset().top;
            }
            function applyFn(fn) {
                return () => {
                    fn();
                    scope.$apply();
                }
            }
            $($window).scrollTop(0);
            updateElTop();
            updateDocumentScrollTop();
            $document.on('scroll', applyFn(updateDocumentScrollTop));
        }
    }
}];

export default angular.module('atmt.stickyBar', [])
    .controller('AtmtStickyBarController', AtmtStickyBarController)
    .directive('atmtStickyBar', atmtStickyBarDirective);